import type { JSX } from "react";

import svgs, { type SvgName } from "../../assets/auto_gen/svgs.js";
import { cn } from "../../lib/cn.js";

export interface SVGLoaderProps {
  /** Key of the SVG in the generated map — the file name without `.svg`. */
  src: SvgName;
  className?: string;
  "aria-label"?: string;
  "aria-hidden"?: boolean;
}

/**
 * Renders an inline SVG from the auto-generated map (src/assets/auto_gen/svgs.ts,
 * produced by scripts/inline-svg.mjs). Mirrors fynd-erp's SVGLoader.
 *
 * Uses dangerouslySetInnerHTML because the markup is generated at build time
 * from trusted, in-repo SVG files (never user input). The inner <svg> fills the
 * wrapper, so control size and colour via className (e.g. "h-8 w-8 text-white").
 */
export function SVGLoader({
  src,
  className,
  "aria-label": ariaLabel,
  "aria-hidden": ariaHidden,
}: SVGLoaderProps): JSX.Element {
  const content = svgs[src] ?? "";
  return (
    <span
      role={ariaLabel ? "img" : undefined}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden ?? (ariaLabel ? undefined : true)}
      className={cn(
        "inline-flex items-center justify-center [&>svg]:h-full [&>svg]:w-full",
        className,
      )}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
}

export default SVGLoader;
